export const SEQUENCE_ID_CUSTOM_FIELD = 'elements:sequenceID'
